import React from 'react';
import { useForm, ValidationError } from '@formspree/react';

interface ContactFormProps {
  onClose: () => void;
}

export function ContactForm({ onClose }: ContactFormProps) {
  const [state, handleSubmit] = useForm("xrbkalnv");
  
  if (state.succeeded) {
    return (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
      }}>
        <div style={{
          backgroundColor: '#fff',
          padding: '2rem',
          borderRadius: '8px',
          maxWidth: '400px',
          width: '90%',
          textAlign: 'center',
        }}>
          <p style={{ fontSize: '18px', marginBottom: '1rem', color: '#28a745' }}>
            Thanks for your message! We'll get back to you soon.
          </p>
          <button
            onClick={onClose}
            style={{
              backgroundColor: '#FF4F00',
              color: '#fff',
              border: 'none',
              padding: '0.5rem 1rem',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '14px',
            }}
          >
            Close
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
    }}>
      <div style={{
        backgroundColor: '#fff',
        padding: '2rem',
        borderRadius: '8px',
        maxWidth: '500px',
        width: '90%',
        position: 'relative',
      }}>
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '1rem',
            right: '1rem',
            backgroundColor: 'transparent',
            border: 'none',
            fontSize: '20px',
            cursor: 'pointer',
            color: '#666',
          }}
        >
          ×
        </button>
        
        <h3 style={{ marginTop: 0, marginBottom: '1.5rem', color: '#222' }}>Contact Us</h3>
        
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          <div>
            <label htmlFor="email" style={{ display: 'block', marginBottom: '0.5rem', color: '#333', fontWeight: '500' }}>
              Email Address
            </label>
            <input
              id="email"
              type="email" 
              name="email"
              style={{
                width: '100%',
                padding: '0.75rem',
                border: '1px solid #ddd',
                borderRadius: '4px',
                fontSize: '14px',
                boxSizing: 'border-box',
              }}
              required
            />
            <ValidationError 
              prefix="Email" 
              field="email"
              errors={state.errors}
              style={{ color: '#dc3545', fontSize: '12px', marginTop: '0.25rem' }}
            />
          </div>
          
          <div>
            <label htmlFor="message" style={{ display: 'block', marginBottom: '0.5rem', color: '#333', fontWeight: '500' }}>
              Message
            </label>
            <textarea
              id="message"
              name="message"
              rows={4}
              style={{
                width: '100%',
                padding: '0.75rem',
                border: '1px solid #ddd',
                borderRadius: '4px',
                fontSize: '14px',
                boxSizing: 'border-box',
                resize: 'vertical',
              }}
              required
            />
            <ValidationError 
              prefix="Message" 
              field="message"
              errors={state.errors}
              style={{ color: '#dc3545', fontSize: '12px', marginTop: '0.25rem' }}
            />
          </div>
          
          <button 
            type="submit" 
            disabled={state.submitting}
            style={{
              backgroundColor: state.submitting ? '#ccc' : '#FF4F00',
              color: '#fff',
              border: 'none',
              padding: '0.75rem 1.5rem',
              borderRadius: '4px',
              cursor: state.submitting ? 'not-allowed' : 'pointer',
              fontSize: '16px',
              fontWeight: '600',
              marginTop: '0.5rem',
            }}
          >
            {state.submitting ? 'Submitting...' : 'Send Message'}
          </button>
        </form>
      </div>
    </div>
  );
}
